import { currentState, internalCurrentState } from "./config";

/**
 * Change the search params of the current URL
 * @param {*} key
 * @param {*} value
 */
export function changeURLSearchParam(key, value) {
  const currentURL = window.location;
  let newURL = new URL(currentURL);

  newURL.searchParams.set(key, value);
  history.pushState({}, "", newURL);
}

/**
 * Parse the initial URL
 */
export function parseURLToConfig() {
  const currentURL = window.location;
  const currentSearch = currentURL.search;

  let newURL = new URL(window.location);

  if (currentSearch != "") {
    const searchParams = new URLSearchParams(currentSearch);

    if (searchParams.has("obs")) {
      currentState.currentObservatory = searchParams.get("obs").toUpperCase();
    } else {
      newURL.searchParams.set("obs", currentState.currentObservatory);
    }

    if (searchParams.has("panel")) {
      currentState.currentPanel = Number(searchParams.get("panel"));
    } else {
      newURL.searchParams.set("panel", currentState.currentPanel);
    }
  } else {
    newURL.searchParams.set("obs", currentState.currentObservatory);
    newURL.searchParams.set("panel", currentState.currentPanel);
  }

  history.pushState({}, "", newURL);
}

export function internalParseURLToConfig() {
  const currentURL = window.location;
  const currentSearch = currentURL.search;

  let newURL = new URL(window.location);

  if (currentSearch != "") {
    const searchParams = new URLSearchParams(currentSearch);

    if (searchParams.has("panel")) {
      internalCurrentState.currentPanel = searchParams.get("panel");
    } else {
      newURL.searchParams.set("panel", internalCurrentState.currentPanel);
    }
  } else {
    newURL.searchParams.set("panel", internalCurrentState.currentPanel);
  }

  history.pushState({}, "", newURL);
}
